import type { TourFrame, TourStep } from '@carboncopyco/types';
import { selectActiveFrameId, selectActiveStepId } from '../../store';
import { useTourSelector } from '../store';

export const useReplayerActiveState = (
  frames: TourFrame[],
  uuid: string
): {
  activeFrame: TourFrame;
  activeStep: TourStep;
} => {
  const activeFrameId = useTourSelector(selectActiveFrameId(uuid));
  const activeStepId = useTourSelector(selectActiveStepId(uuid));

  const activeFrame = frames?.find((frame) => frame.id === activeFrameId);
  const activeStep = activeFrame?.steps?.find(
    (step) => step.stepId === activeStepId
  );

  return {
    activeFrame: activeFrame ?? null,
    activeStep: activeStep ?? null,
  };
};
